import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import icon from '../../../static/icons/help-button.svg';
import exclamationIcon from '../../../static/icons/exclamation-button.png';
import * as styles from './BottomTooltip.scss';

class BottomTooltip extends Component {
  state = {
    showTooltip: false
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }


  setWrapperRef = (node) => {
    this.wrapperRef = node;
  };

  setVisibility = (showTooltip) => { this.setState({ showTooltip }); };

  handleClickOutside = (event) => {
    if (this.props.closeOnClickOutside && this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ showTooltip: false });
    }
  };

  clickHandler = (evt) => {
    evt.preventDefault();

    const showTooltip = !this.state.showTooltip;
    this.setState({ showTooltip });
    if (this.props.onToggle) {
      this.props.onToggle(evt, showTooltip);
    }
  };

  renderIcon = () => ((!!this.props.icon)
    ? this.props.icon
    : (<img src={(this.props.warnTooltip) ? exclamationIcon : icon} alt="help-icon" />));

  render() {
    const handleHoverEvent = this.props.showOnHover
      ? { onMouseEnter: () => this.setVisibility(true), onMouseLeave: () => this.setVisibility(false) }
      : Object.create(null);

    return (
      <div
        className={cx(styles.tooltipContainer, this.props.className, { open: this.state.showTooltip })}
        onClick={this.clickHandler}
        ref={this.setWrapperRef}
        {...handleHoverEvent}
      >
        {this.renderIcon()}

        {this.state.showTooltip && (
          <div className={cx(styles.tooltip, this.props.packageName)}>
            {this.props.msg}
            {this.props.children}
          </div>
        )}
      </div>
    );
  }
}


BottomTooltip.propTypes = {
  msg: PropTypes.any,
  className: PropTypes.string,
  onToggle: PropTypes.func,
  showOnHover: PropTypes.bool,
  packageName: PropTypes.string,
  children: PropTypes.node,
  warnTooltip: PropTypes.bool,
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.element]),
  closeOnClickOutside: PropTypes.bool
};

export default BottomTooltip;
